const DASHBOARD_INIT = 'DASHBOARD_INIT';
const DASHBOARD_INIT_SUCCESS = 'DASHBOARD_INIT_SUCCESS';
const DASHBOARD_INIT_FAIL = 'DASHBOARD_INIT_FAIL';
const DASHBOARD_SET_FILTER_DATE = 'DASHBOARD_SET_FILTER_DATE';
const DASHBOARD_SET_FILTER_RESTAURANT_ID = 'DASHBOARD_SET_FILTER_RESTAURANT_ID';
const DASHBOARD_SET_FILTER_GROUP = 'DASHBOARD_SET_FILTER_GROUP';

const DASHBOARD_CHART_LOAD = 'DASHBOARD_CHART_LOAD';
const DASHBOARD_CHART_LOAD_SUCCESS = 'DASHBOARD_CHART_LOAD_SUCCESS';
const DASHBOARD_CHART_LOAD_FAIL = 'DASHBOARD_CHART_LOAD_FAIL';

export const onInit = () => {
    return {type: DASHBOARD_INIT }
}

export const onInitSuccess = (data) => {
    return {type: DASHBOARD_INIT_SUCCESS, data }
}

export const onInitFail = () => {
    return {type: DASHBOARD_INIT_FAIL }
}
export const setFilterDate = (date) => {
    return {type: DASHBOARD_SET_FILTER_DATE, date }
}
export const setFilterRestaurant = (id) => {
    return {type: DASHBOARD_SET_FILTER_RESTAURANT_ID, id }
}

export const onChartLoad = () => {
    return {type: DASHBOARD_CHART_LOAD }
}
export const onChartLoadSuccess = (data) => {
    return {type: DASHBOARD_CHART_LOAD_SUCCESS, data }
}
export const onChartLoadFail = () => {
    return {type: DASHBOARD_CHART_LOAD_FAIL }
}
export const setFilterGroup = (group) => {
    return {type: DASHBOARD_SET_FILTER_GROUP, group }
}

